import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJobPaymentEmailTemplate.Delete.IRequest;
type Response = Api.Core.ClaimJobPaymentEmailTemplate.Delete.IResponse;
type Headers = Api.Core.ClaimJobPaymentEmailTemplate.Delete.IHeaders;
const url = '/api/Management/ClaimJobPaymentEmailTemplate/:id';
export default async function claimJobPaymentEmailTemplateDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
